import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";

export const statisticsTabInit = (tabId, dateFilter) => ({
    type: actionTypes.STATISTICS_TAB_INIT,
    payload: {
        tabId: tabId,
        dateFilter: dateFilter,
        customerList: []
    }
});

export const getStatisticsRequest = (
    tabId,
    statsParams,
    filter,
    orderBy,
    asc,
    offset,
    visibleOnly,
    handler = handlers.GET_STATISTICS
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_STATISTICS,
        params: {
            colorStatsTypeIds: statsParams.colorStatsTypeIds,
            products: statsParams.productList,
            fandecks: statsParams.fandeckList,
            colors: statsParams.formulaList,
            bases: statsParams.baseList,
            packages: statsParams.packageList,
            customers: statsParams.customerList,
            dateFrom: statsParams.dateFrom,
            dateTo: statsParams.dateTo,
            search: filter,
            searchByColumns: statsParams.searchByColumns,
            orderBy: orderBy,
            asc: asc,
            offset: offset,
            rowCount: config.MAX_STATISTICS_LIMIT,
            visibleOnly: visibleOnly
        }
    },
    method: handler,
    tabId: tabId
});

export const loadFormulaDataFromStatistics = (tabId, statId) => ({
    type: actionTypes.LOAD_FORMULA_DATA_FROM_STATS,
    payload: {
        tabId: tabId,
        colorStatsId: statId
    }
});

export const loadFormulaMetaDataFromStatistics = (tabId, statId, next) => ({
    type: actionTypes.LOAD_FORMULA_META_DATA_FROM_STATS,
    payload: {
        tabId: tabId,
        colorStatsId: statId,
        next: next
    }
});

export const reloadStatistics = (tabId) => ({
    type: actionTypes.STATISTICS_TAB_GET_FORMULA_LIST_WITH_OFFSET,
    payload: {
        tabId: tabId
    }
});

export const changeSorting = (tabId, criterion, asc) => ({
    type: actionTypes.STATISTICS_TAB_SAVE_SORTING,
    payload: {
        tabId: tabId,
        criterion: criterion,
        asc: asc
    }
});

export const getCorrectionHistory = (tabId, colorStatsId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CORRECTION_HISTORY,
        params: {
            childColorStatsId: colorStatsId
        }
    },
    method: handlers.GET_CORRECTION_HISTORY,
    tabId: tabId
});

export const saveFilter = (tabId, filter) => ({
    type: actionTypes.STATISTICS_SAVE_FILTER,
    payload: {
        tabId: tabId,
        filter: filter
    }
});

export const changeOffset = (tabId, offset) => ({
    type: actionTypes.STATISTICS_CHANGE_OFFSET,
    payload: {
        tabId: tabId,
        offset: offset
    }
});

export const exportStats = (tabId, all, path) => ({
    type: actionTypes.PREPARE_FILE_STATS_DATA,
    payload: {
        tabId: tabId,
        all: all,
        path: path
    }
});

export const setHiddenStatus = (tabId, statsId, hidden) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_STATISTIC_HIDDEN,
        params: {
            colorStatsId: statsId,
            hidden: hidden
        }
    },
    method: handlers.SET_STATISTIC_HIDDEN,
    tabId: tabId
});

export const showHiddenStats = (tabId, showHidden) => ({
    type: actionTypes.STATISTICS_SET_SHOW_HIDDEN,
    payload: {
        tabId: tabId,
        showHidden: showHidden
    }
});

export const saveStatisticNote = (tabId, statsId, note) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_STATISTIC_MORE_INFO,
        params: {
            colorStatsId: statsId,
            moreInfo: note
        }
    },
    method: handlers.SET_STATISTIC_MORE_INFO,
    tabId: tabId
});

export const startRetint = (tabId, packageCount) => ({
    type: actionTypes.STATISTICS_TAB_START_RETINT,
    payload: {
        tabId: tabId,
        packageCount: packageCount
    }
});

export const addColorStatsToStatsAndDispense = (tabId, packageCount) => ({
    type: actionTypes.ADD_COLOR_STATS_FROM_STATS_AND_DISPENSE,
    payload: {
        tabId: tabId,
        packageCount: packageCount
    }
});

export const addHistoryColorToStatistics = (tabId, statisticsId, packageCount, customerId, dispenseNote) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_COLOR_STATS_FROM_STATS,
        params: {
            colorStatsId: statisticsId,
            packageCount: packageCount,
            customerId: customerId,
            moreInfo: dispenseNote
        }
    },
    method: handlers.ADD_COLOR_STATS_FROM_STATS,
    tabId: tabId,
    next: {
        packageCount: packageCount
    }
});

export const setNumberOfPackages = (tabId, value) => ({
    type: actionTypes.STATISTICS_TAB_SET_NUMBER_OF_PACKAGES,
    payload: {
        tabId: tabId,
        numberOfPackages: value
    }
});
